import { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { checkLogin } from "../../store/features/login/loginSlice";
import { useHistory } from "react-router-dom";
import { tokenDecode } from "../../utils/helper";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import axios from "axios";
import { config } from "../../utils/config";
import logo from "../../icons/ix_logo.png";

const { apiEndpoint } = config;

const LOGIN_STYLES = `
.lgn-wrap {
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(12px, 3vh, 26px);
  background: radial-gradient(1200px 600px at 12% 0%, #2a1657 0%, rgba(42,22,87,0) 60%),
              linear-gradient(160deg, #150b2e 0%, #24123f 40%, #3a2482 100%);
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
}
.lgn-card {
  width: 100%;
  max-width: 1000px;
  height: 100%;
  max-height: 640px;
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  background: #ffffff;
  border-radius: 26px;
  overflow: hidden;
  box-shadow: 0 50px 100px -30px rgba(10, 4, 30, 0.65);
}

/* ---------- Brand panel ---------- */
.lgn-brand {
  position: relative;
  padding: 40px 42px;
  color: #f4f1ff;
  overflow: hidden;
  background: linear-gradient(155deg, #1c1038 0%, #3d2496 48%, #7c5cfc 105%);
  display: flex;
  flex-direction: column;
}
.lgn-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(2px);
  opacity: 0.55;
  pointer-events: none;
}
.lgn-blob-1 {
  width: 320px; height: 320px;
  right: -110px; top: -120px;
  background: radial-gradient(circle at 30% 30%, #9d7bff, rgba(124,92,252,0));
  animation: lgn-float 9s ease-in-out infinite;
}
.lgn-blob-2 {
  width: 240px; height: 240px;
  left: -90px; bottom: -80px;
  background: radial-gradient(circle at 60% 40%, #5b3fc8, rgba(76,47,179,0));
  animation: lgn-float 11s ease-in-out infinite reverse;
}
.lgn-grid-overlay {
  position: absolute; inset: 0;
  background-image: linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px),
                    linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px);
  background-size: 46px 46px;
  mask-image: radial-gradient(600px 400px at 30% 25%, #000 0%, transparent 80%);
  pointer-events: none;
}
@keyframes lgn-float {
  0%, 100% { transform: translateY(0) translateX(0); }
  50% { transform: translateY(-22px) translateX(10px); }
}
.lgn-brand-inner { position: relative; z-index: 1; display: flex; flex-direction: column; flex: 1; min-height: 0; }
.lgn-logo-row { display: flex; align-items: center; gap: 13px; margin-bottom: auto; }
.lgn-logo-badge {
  flex: 0 0 auto; width: 46px; height: 46px; border-radius: 13px;
  background: #ffffff; display: grid; place-items: center;
  box-shadow: 0 8px 20px -6px rgba(0,0,0,0.35);
}
.lgn-logo-badge img { width: 30px; height: 30px; object-fit: contain; }
.lgn-logo-row span {
  font-family: 'Sora', 'Inter', sans-serif; font-weight: 700; font-size: 17px; letter-spacing: 0.02em;
}
.lgn-headline {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 27px; line-height: 1.22; font-weight: 700; margin: 22px 0 12px;
  letter-spacing: -0.01em;
}
.lgn-sub { font-size: 13px; line-height: 1.55; color: #cbbdf5; max-width: 360px; margin: 0 0 22px; }
.lgn-feats { display: flex; flex-direction: column; gap: 12px; margin-bottom: auto; }
.lgn-feat { display: flex; align-items: center; gap: 12px; font-size: 13.5px; color: #e7e0ff; }
.lgn-feat i {
  flex: 0 0 auto; width: 26px; height: 26px; border-radius: 8px;
  display: grid; place-items: center;
  background: rgba(255,255,255,0.14); border: 1px solid rgba(255,255,255,0.22);
}
.lgn-feat svg { width: 14px; height: 14px; }
.lgn-brand-foot { font-size: 11.5px; color: #a892e8; letter-spacing: 0.04em; margin-top: 22px; }

/* ---------- Form panel ---------- */
.lgn-form-panel { padding: 40px 48px; display: flex; flex-direction: column; justify-content: center; overflow-y: auto; }
.lgn-form-logo { display: none; }
.lgn-title { font-family: 'Sora', 'Inter', sans-serif; font-size: 24px; font-weight: 700; color: #1F2430; margin: 0; }
.lgn-title-sub { font-size: 13px; color: #6B7280; margin: 8px 0 30px; }
.lgn-label {
  display: block; font-size: 11.5px; font-weight: 700; color: #4B5563;
  text-transform: uppercase; letter-spacing: 0.06em; margin: 0 0 7px;
}
.lgn-field { position: relative; margin-bottom: 18px; }
.lgn-field > svg.lgn-lead {
  position: absolute; left: 13px; top: 50%; transform: translateY(-50%);
  color: #9CA3AF; width: 19px; height: 19px; pointer-events: none;
}
.lgn-input {
  width: 100%; height: 48px; padding: 0 44px 0 42px;
  border-radius: 12px; border: 1px solid #E3E6EC;
  font-size: 14px; color: #1F2430; background: #FCFCFD;
  outline: none; box-sizing: border-box;
  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
}
.lgn-input::placeholder { color: #9CA3AF; }
.lgn-input:hover { border-color: #CBD0DA; }
.lgn-input:focus { border-color: #7c5cfc; background: #ffffff; box-shadow: 0 0 0 4px rgba(124,92,252,0.14); }
.lgn-eye {
  position: absolute; right: 8px; top: 50%; transform: translateY(-50%);
  width: 30px; height: 30px; border: none; background: transparent;
  color: #9CA3AF; cursor: pointer; display: grid; place-items: center; border-radius: 8px;
}
.lgn-eye:hover { color: #4c2fb3; background: #f3f0fc; }
.lgn-row { display: flex; justify-content: flex-end; margin: 2px 0 22px; }
.lgn-forgot { font-size: 12.5px; color: #4c2fb3; font-weight: 600; text-decoration: none; }
.lgn-forgot:hover { text-decoration: underline; }
.lgn-btn {
  width: 100%; height: 48px; border: none; border-radius: 12px;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #fff; font-size: 14px; font-weight: 700; letter-spacing: 0.02em;
  cursor: pointer; box-shadow: 0 16px 30px -8px rgba(76,47,179,0.5);
  transition: transform .15s ease, box-shadow .15s ease, filter .15s ease;
}
.lgn-btn:hover:not(:disabled) { transform: translateY(-1px); filter: brightness(1.05); box-shadow: 0 20px 36px -8px rgba(76,47,179,0.55); }
.lgn-btn:active:not(:disabled) { transform: translateY(0); }
.lgn-btn:disabled { opacity: 0.6; cursor: not-allowed; box-shadow: none; }
.lgn-foot { text-align: center; font-size: 12px; color: #9CA3AF; margin-top: 26px; }

@media (max-width: 860px) {
  .lgn-wrap { height: auto; min-height: 100vh; min-height: 100dvh; overflow-y: auto; }
  .lgn-card { grid-template-columns: 1fr; max-width: 440px; height: auto; max-height: none; }
  .lgn-brand { display: none; }
  .lgn-form-panel { padding: 40px 30px; overflow-y: visible; }
  .lgn-form-logo { display: block; text-align: center; margin-bottom: 20px; }
  .lgn-form-logo img { height: 46px; }
}

@media (min-width: 861px) and (max-height: 640px) {
  .lgn-headline { font-size: 24px; margin: 20px 0 10px; }
  .lgn-sub { margin-bottom: 20px; }
  .lgn-feats { gap: 10px; }
  .lgn-brand-foot { margin-top: 20px; }
  .lgn-title-sub { margin-bottom: 20px; }
}
`;

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch<any>();
  const loginData = useSelector((state: any) => state.loginReducer);
  const { loading } = loginData;
  const [user, setUser] = useState({ email: "", password: "" });
  const [showPass, setShowPass] = useState(false);
  const [errorMessage, setErrorMessage] = useState({ email: true, password: true });

  const loginMannage = async () => {
    dispatch(checkLogin(user));
  };

  const loginChecker = (e: any) => {
    e.preventDefault();
    if (errorMessage.email || errorMessage.password) {
      toast.error("Email and password is required !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      loginMannage();
    }
  };

  const onChangeHandler = (e: any) => {
    setUser({ ...user, [e.target.name]: e.target.value });
    setErrorMessage({ ...errorMessage, [e.target.name]: e.target.value ? false : true });
  };

  const redirectHandler = () => {
    try {
      const decode = tokenDecode();
      if (decode) {
        history.push("/dashboard");
      } else {
        history.push("/");
      }
    } catch (error) {
      history.push("/");
    }
  };

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const navigateToSeller: any = urlParams.get("navigateToSeller");

  async function getSellerAuth() {
    const AdminToken: any = urlParams.get("token");
    const Selleremail: any = urlParams.get("email");
    const SellerProviderid: any = urlParams.get("provider_id");
    const { data }: any = await axios({
      url: `${apiEndpoint}/seller_login_via_admin`,
      method: "POST",
      headers: {
        "x-custom-authorization": `Bearer ${AdminToken}`,
      },
      data: {
        email: Selleremail,
        provider_id: SellerProviderid,
      },
    });
    if (data.code === "200") {
      sessionStorage.setItem("us_st_d", data?.data?.token);
      history.push("/dashboard");
    }
  }

  useEffect(() => {
    if (loginData.data && navigateToSeller === null) {
      redirectHandler();
    }
    if (loginData.error?.message) {
      toast.error(loginData.error.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (navigateToSeller === "true") {
      getSellerAuth();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginData]);

  const Check = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );

  return (
    <>
      <style>{LOGIN_STYLES}</style>

      <div className="lgn-wrap">
        <div className="lgn-card">
          {/* Brand side */}
          <div className="lgn-brand">
            <span className="lgn-blob lgn-blob-1" />
            <span className="lgn-blob lgn-blob-2" />
            <span className="lgn-grid-overlay" />

            <div className="lgn-brand-inner">
              <div className="lgn-logo-row">
                <span className="lgn-logo-badge"><img src={logo} alt="Inventoryless" /></span>
                <span>Inventoryless</span>
              </div>

              <h1 className="lgn-headline">
                Your storefront,<br />under one roof.
              </h1>
              <p className="lgn-sub">
                Inventoryless brings your products, stock, orders and payouts together in a single seller workspace.
              </p>

              <div className="lgn-feats">
                <div className="lgn-feat"><i><Check /></i> Real-time catalogue </div>
                <div className="lgn-feat"><i><Check /></i> End-to-end order, return &amp; payout visibility</div>
                <div className="lgn-feat"><i><Check /></i> ONDC-native selling, from listing to grievance</div>
              </div>

              <div className="lgn-brand-foot">© {new Date().getFullYear()} Inventoryless · Seller Admin</div>
            </div>
          </div>

          {/* Form side */}
          <div className="lgn-form-panel">
            <div className="lgn-form-logo">
              <img src={logo} alt="Inventoryless" />
            </div>

            <h2 className="lgn-title">Welcome back</h2>
            <p className="lgn-title-sub">Sign in to your seller dashboard</p>

            <form onSubmit={(e) => loginChecker(e)}>
              <label className="lgn-label">Email address</label>
              <div className="lgn-field">
                <PersonOutlineIcon className="lgn-lead" />
                <input
                  className="lgn-input"
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={user.email}
                  onChange={(e) => onChangeHandler(e)}
                  autoComplete="username"
                />
              </div>

              <label className="lgn-label">Password</label>
              <div className="lgn-field">
                <LockOpenIcon className="lgn-lead" />
                <input
                  className="lgn-input"
                  type={showPass ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  value={user.password}
                  onChange={(e) => onChangeHandler(e)}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="lgn-eye"
                  onClick={() => setShowPass((s) => !s)}
                  aria-label={showPass ? "Hide password" : "Show password"}
                  tabIndex={-1}
                >
                  {showPass ? <VisibilityOffOutlinedIcon style={{ fontSize: 19 }} /> : <VisibilityOutlinedIcon style={{ fontSize: 19 }} />}
                </button>
              </div>

              <div className="lgn-row">
                <Link className="lgn-forgot" to="/forget-password">Forgot Password?</Link>
              </div>

              <button className="lgn-btn" type="submit" disabled={loading}>
                {loading ? "Signing in..." : "Sign in"}
              </button>
            </form>

            <div className="lgn-foot">Protected access · authorised sellers only</div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default Login;
